import React from 'react';

import { Link } from '~/lib/react-router-dom';

import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { IconButton, Stack, Tooltip } from '@mui/material';

import useToggleState from '~/hooks/useToggleState';

import { getHeroPlannerFormType, isCustomSchedule } from '../utils/heroPlannerScheduleUtils';

import ScheduleDeletionDialog from './ScheduleDeletionDialog';

interface Props {
  scheduleId: string;
  segmentId?: string;
  brandId?: string;
}

function ScheduleRowActions({ scheduleId, segmentId, brandId }: Props) {
  const {
    isToggled: isDeletionModalOpen,
    toggleOn: openDeletionModal,
    toggleOff: closeDeletionModal,
  } = useToggleState(false);

  const formType = getHeroPlannerFormType(segmentId, brandId);

  return (
    <Stack direction="column">
      <Tooltip title="Edit in the editor">
        <IconButton
          component={Link}
          to={`/customer-communication/hero-planner/schedules/${scheduleId}?formType=${formType}`}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Duplicate as a new schedule">
        <IconButton
          component={Link}
          to={`/customer-communication/hero-planner/schedules/${scheduleId}?duplicate=true&formType=${formType}`}
        >
          <ContentCopyIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Open the  deletion modal">
        <IconButton onClick={openDeletionModal}>
          <DeleteIcon />
        </IconButton>
      </Tooltip>
      <ScheduleDeletionDialog
        scheduleId={scheduleId}
        isCustomSchedule={isCustomSchedule(segmentId, brandId)}
        open={isDeletionModalOpen}
        onClose={closeDeletionModal}
      />
    </Stack>
  );
}

export default ScheduleRowActions;
